import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { ScannedProductsService } from "../services/scanned-products.service";
import { routes } from "../../../environments/environment.routes";

export const hasScannedProductsGuard = () => {
  const scannedProductsService = inject(ScannedProductsService);
  const router = inject(Router);

  const hasProducts = scannedProductsService.hasProducts();

  if (!hasProducts) {
    router.navigate([routes.frontend.scan, routes.frontend.scanCamera], {
      queryParamsHandling: "preserve",
    });
    return false;
  }

  return true;
};
